import type { TextStyleRule } from '@doer/frontend-components/creativity-editor';

// Longest-first so "Visa Signature" / "Macro Selecta" win over "Visa" / "Macro" when the matcher is sequential.
const PAYMENT_METHOD_KEYWORDS = [
  'de Crédito Visa y Mastercard Macro',
  'de Crédito Mastercard Macro',
  'de Crédito Visa Macro',
  'American Express Platinum',
  'American Express Black',
  'Débito o Crédito',
  'Con Tarjetas de',
  'Con Tarjeta de',
  'Mastercard Platinum',
  'Mastercard Black',
  'Platinum Macro',
  'Macro Selecta',
  'Visa Signature',
  'Visa Platinum',
  'American Express',
  'Crédito Macro',
  'Débito Macro',
  'Mastercard',
  'Crédito',
  'Débito',
  'Macro',
  'Visa'
];

/** MACRO uses DM Sans across the board — emphasis is bold-only. */
export const PAYMENT_METHOD_RULES: TextStyleRule[] = PAYMENT_METHOD_KEYWORDS.map(match => ({
  match,
  style: { fontWeight: 'bold' }
}));
